const mediaCards = [
  {
    title: '香蕉视频 · 热播大片精选',
    desc: '最新院线级大片高清呈现，震撼视听体验',
    duration: '120分钟',
    tag: '4K超清',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20abstract%20scene%20with%20dramatic%20warm%20lighting%20and%20deep%20shadows%2C%20golden%20film%20grain%20texture%2C%20movie%20theater%20ambiance%2C%20rich%20coral%20and%20amber%20tones%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-banana-hot&orientation=landscape',
  },
  {
    title: '红桃视频 · 独家高清资源',
    desc: '独家高清片源，色彩饱满还原真实',
    duration: '95分钟',
    tag: '蓝光画质',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20rich%20warm%20rose%20and%20coral%20gradients%2C%20soft%20bokeh%20lights%2C%20elegant%20film%20aesthetic%2C%20luxurious%20theater%20atmosphere%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-redpeach-hd&orientation=landscape',
  },
  {
    title: '91视频 · 经典影视修复',
    desc: '经典老片高清修复，重温银幕经典',
    duration: '110分钟',
    tag: '修复版',
    img: 'https://readdy.ai/api/search-image?query=Retro%20classic%20film%20abstract%20with%20warm%20nostalgic%20golden%20tones%2C%20vintage%20film%20grain%2C%20old%20hollywood%20glamour%2C%20elegant%20timeless%20aesthetic%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-91-classic&orientation=landscape',
  },
  {
    title: '蜜桃视频 · 新番速递更新',
    desc: '日漫国漫新番同步，追番党必备',
    duration: '24分钟/集',
    tag: '连载中',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20dreamy%20abstract%20with%20warm%20peach%20sunset%20gradients%2C%20soft%20magical%20particles%2C%20flowing%20color%20transitions%2C%20elegant%20illustration%20feel%2C%20no%20text%2C%20no%20people&width=800&height=450&seq=media-peach-anime&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            精彩推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            99视频聚合平台精选内容推荐，来自香蕉视频、红桃视频、91视频、蜜桃视频的热门资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaCards.map((card, idx) => (
            <article
              key={idx}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs font-medium border border-white/15">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 rounded-full bg-black/50 backdrop-blur-sm text-white text-xs">
                    {card.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-950 text-sm mb-1 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-xs">{card.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}